/*
  State
*/
const state = {
  money: 0,
  questionsData: null,
  endData: null,
  actualQuestion: '1',
  countCycle: 0,
  questionsCycle: [],
  showPopin: false,
  dataPopin: null,
  isEnd: false,
  isWin: false,
  isMobile: false,
  animMoney: false,
  animMoneyReverse: false,
};

/*
  Getters
*/
const getters = {
  getMoney: state => state.money,
  getEndData: state => state.endData,
  getQuestionsData: state => state.questionsData,
  getActualQuestion: state => state.actualQuestion,
  getCycle: state => state.countCycle,
  getQuestionsCycle: state => state.questionsCycle,
  getShowPopin: state => state.showPopin,
  getDataPopin: state => state.dataPopin,
  getEnd: state => state.isEnd,
  getWin: state => state.isWin,
  getMobile: state => state.isMobile,
  getAnimMoney: state => state.animMoney,
  getAnimMoneyReverse: state => state.animMoneyReverse,
};

/*
  Actions
*/
const actions = {

};

/*
  Mutations
*/
const mutations = {
  setMoney(state, payload) {
    state.money = payload;
  },
  setQuestionsData(state, payload) {
    state.questionsData = payload;
  },
  setEndData(state, payload) {
    state.endData = payload;
  },
  setActualQuestion(state, payload) {
    state.actualQuestion = payload;
  },
  setCycle(state, payload) {
    const count = state.countCycle + 1;

    if (count > 1) {
      state.countCycle = 0;
    } else {
      state.countCycle = count;
    }

    if (payload === 'reset') {
      state.countCycle = 0;
    }
  },
  setQuestionCycle(state, payload) {
    state.questionsCycle.splice(payload.index, 1, payload.data);
  },
  setShowPopin(state, payload) {
    state.showPopin = payload;
  },
  setDataPopin(state, payload) {
    state.dataPopin = payload;
  },
  setEnd(state, payload) {
    state.isEnd = payload;
  },
  setWin(state, payload) {
    state.isWin = payload;
  },
  setIsMobile(state, payload) {
    state.isMobile = payload;
  },
  setAnimMoney(state, payload) {
    state.animMoney = payload;
  },
  setAnimMoneyReverse(state, payload) {
    state.animMoneyReverse = payload;
  },
};


module.exports = {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/game.js